module.exports = __webpack_public_path__ + "img/user-icon.86eca126.png";